import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function Products() {
  const products = [
    {
      name: 'Custom T-Shirts',
      description: 'Premium quality t-shirts perfect for your business, team, or event. Available in various styles, fits, and materials.',
      features: [
        'Tri-blend luxury fabric (50/25/25 poly-cotton-rayon)',
        'Over 30 vibrant color options',
        'Sizes XS through 4XL',
        'Superior comfort and durability',
        'Professional tear-away label',
        'Shoulder-to-shoulder taping'
      ],
      image: 'https://highline-apparel.com/images/shirt2.jpg',
      accent: 'cyan'
    },
    {
      name: 'Hoodies',
      description: 'Premium fleece hoodies available in three distinct weights and styles to match your exact needs and preferences.',
      features: [
        'Choose from lightweight (8oz), medium (9oz), or heavy (10oz) fleece',
        'Up to 50+ color options across all styles',
        'Sizes XS through 5XL available',
        'Premium cotton-poly blends for superior softness',
        'Durable construction with double-needle stitching',
        'Professional-grade embroidery available'
      ],
      image: 'https://stackblitz.com/storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBOXVKRkE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--b8a98628ea4930c72bb24d51ac935d73b567887e/hoodie.jpg',
      accent: 'magenta'
    },
    {
      name: 'Embroidery & Patches',
      description: 'Professional-grade embroidery services for all your apparel needs. From corporate polos and dress shirts to custom hats and accessories, our precision embroidery adds a premium touch to any garment. Perfect for uniforms, corporate wear, and brand merchandise.',
      features: [
        'Multiple patch styles (3D embroidery, rubber, leather, full-color)',
        'Premium structured 6-panel design with snapback',
        'Over 40 vibrant color options',
        'Hybrid print + embroidery patches available',
        'Rhinestone patch options',
        'Low minimums on all styles'
      ],
      image: 'https://stackblitz.com/storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBK09KRkE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--26e5e60acc4a8a95d6bb11a84c8d4548a400f07a/hat2.jpg',
      accent: 'cyan'
    }
  ];

  return (
    <div id="products" className="py-24 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            Quality meets creativity in every stitch and print
          </h2>
        </div>

        <div className="space-y-16">
          {products.map((product, index) => (
            <div 
              key={product.name}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} 
                items-center gap-12 bg-gray-900 rounded-2xl p-8 transform hover:scale-[1.02] transition-transform duration-300`}
            >
              <div className="w-full lg:w-1/2 space-y-6">
                <h3 className={`text-2xl font-bold ${product.accent === 'cyan' ? 'text-cyan-500' : 'text-magenta-500'}`}>
                  {product.name}
                </h3>
                <p className="text-gray-300 text-lg">
                  {product.description}
                </p>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {product.features.map((feature) => (
                    <li key={feature} className="flex items-start text-gray-400">
                      <svg className="w-5 h-5 mr-2 text-cyan-500 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <Link 
                  to="/start-project"
                  className={`inline-flex items-center px-6 py-3 rounded-lg text-sm font-medium
                    ${product.accent === 'cyan' 
                      ? 'bg-cyan-500 text-black hover:bg-cyan-400' 
                      : 'bg-magenta-500 text-black hover:bg-magenta-400'
                    } transition-colors duration-200`}
                >
                  Customize Now
                  <ArrowRightIcon className="ml-2 h-4 w-4" />
                </Link>
              </div>
              <div className="w-full lg:w-1/2">
                <div className="relative w-full h-0 pb-[75%] bg-gray-800 rounded-lg overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}